import i18n from '@/i18n';

export const CURRENCIES = ['EUR', 'GBP', 'CHF', 'SEK', 'DKK', 'NOK', 'PLN', 'CZK', 'HUF', 'RON'];

export const EU_COUNTRIES = [
  ['ES', 'España'], ['FR', 'France'], ['DE', 'Deutschland'], ['IT', 'Italia'], ['PT', 'Portugal'], ['NL', 'Nederland'], ['BE', 'Belgique'],
  ['AT', 'Österreich'], ['IE', 'Ireland'], ['PL', 'Polska'], ['SE', 'Sverige'], ['DK', 'Danmark'], ['FI', 'Suomi'], ['GR', 'Ελλάδα'],
  ['CZ', 'Česko'], ['HU', 'Magyarország'], ['RO', 'România'], ['LU', 'Luxembourg'], ['HR', 'Hrvatska'], ['SK', 'Slovensko'], ['SI', 'Slovenija'],
  ['BG', 'България'], ['LT', 'Lietuva'], ['LV', 'Latvija'], ['EE', 'Eesti'], ['CY', 'Κύπρος'], ['MT', 'Malta'],
  ['CH', 'Schweiz (no UE)'], ['GB', 'United Kingdom (no UE)'], ['NO', 'Norge (no UE)'],
];

export const ES_PROVINCES = ['A Coruña', 'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Barcelona', 'Burgos', 'Cáceres', 'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Girona', 'Granada', 'Guadalajara', 'Gipuzkoa', 'Huelva', 'Huesca', 'Illes Balears', 'Jaén', 'La Rioja', 'Las Palmas', 'León', 'Lleida', 'Lugo', 'Madrid', 'Málaga', 'Murcia', 'Navarra', 'Ourense', 'Palencia', 'Pontevedra', 'Salamanca', 'Santa Cruz de Tenerife', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Bizkaia', 'Zamora', 'Zaragoza', 'Ceuta', 'Melilla'];

const LOCALE_BY_LANG = { es: 'es-ES', en: 'en-GB', fr: 'fr-FR', de: 'de-DE', it: 'it-IT' };
export const currentLocale = () => { const l = (i18n.language || 'es').slice(0, 2); return LOCALE_BY_LANG[l] || l; };

export const formatMoney = (amount, currency = 'EUR') =>
  new Intl.NumberFormat(currentLocale(), { style: 'currency', currency: currency || 'EUR' }).format(Number(amount) || 0);

export const formatDate = (iso, opts = { day: '2-digit', month: '2-digit', year: 'numeric' }) =>
  iso ? new Intl.DateTimeFormat(currentLocale(), opts).format(new Date(iso)) : '';

export const formatDateTime = (iso) => formatDate(iso, { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

export const countryName = (code) => (EU_COUNTRIES.find(([c]) => c === code) || [code, code])[1];
